export { default } from './AggregatedStarRating';
